module.exports = __webpack_public_path__ + "img/6.362e191f.svg";